import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

declare const __API_URL__: string;

/**
 * Dev (no __API_URL__): default `/api/auth` path is same-origin, Vite proxy
 * forwards to the local CP. Prod (CF Pages → CF Tunnel API): point at the
 * full API origin so better-auth uses absolute URLs and `credentials:
 * "include"` carries the cross-site cookie. The CP must be configured with
 * `EXEGESIS_AUTH_CROSS_SITE=1` in production for SameSite=None cookies.
 */
const apiBase = typeof __API_URL__ !== "undefined" ? __API_URL__ : "";

export const authClient = createAuthClient({
  baseURL: apiBase || undefined,
  plugins: [magicLinkClient()],
});
